import React, {useEffect, useState} from 'react';
import {ISsqDataDocument, SsqDataRepository} from "repositories/SsqDataRepository";
import {getHighlightedTextFromHtml} from "util/commonUtils";
import {AccountService} from "repositories/AccountService";
import clsx from "clsx";
import axios from "axios";
import parse from "html-react-parser";
import SimpleUserProfile from "communitypage/common/SimpleUserProfile";
import {LanguageService} from "language/LanguageService";
import {LANG_KO_KR, langutil} from "language/langutil";
import CommunityPostInfo from "communitypage/common/CommunityPostInfo";
import {IfDocCommentInfo} from "models/IfSsqDataDocCommentEntity";
import {useLoginInfo} from 'hooks/useLoginInfo';
import {loginutil} from "util/loginutil";
import {useLoginPopup} from "hooks/useLoginPopup";
import {CommentWrap} from "style/CommonStyledComponents";
import {SsqImages} from "images/SsqImages";

interface Props {
  accountService?: AccountService;
  ssqDocument?: ISsqDataDocument;
  ssqDataRepository: SsqDataRepository;
  getTranslation: Function;
  languageService: LanguageService;
  clickedTag: Function;
  displayLoginPopup: Function;
  commentList: Array<IfDocCommentInfo>;
}

const QnaDocListItem = (props: Props) => {
  const [isEmployee, setIsEmployee] = useState(false);
  const [tags, setTags] = useState([]);
  const {country, lang} = langutil.splitLangCode(props.languageService.lang());
  const [comment, setComment] = useState([]);
  const loginInfo = useLoginInfo();
  const showLoginPopup = useLoginPopup();
  const [checkDate, setCheckDate] = useState(false);

  useEffect(() => {
    setIsEmployee(props.ssqDocument.employ);
    axios.get('/api/guest/ssqData/doctaglist/taggrplist', {
      params: {
        docId: props.ssqDocument.id,
        lang: props.languageService.getLanguage()
      }
    }).then((res) => {
      setTags(res?.data || []);
    });
    axios.get('/api/guest/ssqData/doccomment/list', {
      params: {docId: props.ssqDocument.id}
    }).then((res) => {
      setComment(res?.data || []);
    });
  }, []);

  //14일 이전 날짜 계산
  const checkNewDoc = () => {
    const nowDate = new Date(); // 오늘
    const formatDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);

    const beforeDay = formatDate.getTime() - 1209600000; // 오늘날짜 - 14일
    const dbDate = new Date(props.ssqDocument.updateTime);

    const isWithIn14 = dbDate.getTime() >= beforeDay;
    return setCheckDate(isWithIn14);
  };

  useEffect(() => {
    checkNewDoc();
  }, []);

  return (
    <li>
      <div className="tag">
        {/*partner qna 답변상태*/}
        {/*<div className={"state wait"}>대기</div>*/}
        {/*<div className={"state proc"}>진행</div>*/}
        {/*<div className={"state done"}>완료</div>*/}
        {tags.map((tag, index) => (
          <span key={index} onClick={() => props.clickedTag(tag.tag)}>#{tag?.tag}</span>
        ))}
      </div>
      <div className="content-row">
        <div className="qna-check">
          <div className={clsx("icon-qna", props.ssqDocument.finished ? "a" : "q")}>
            <span style={{display: props.languageService.getLanguage() == LANG_KO_KR ? "" : "none"}}>
              {props.getTranslation("I18N_TITLE_COMMUNITY_BOARD_DOCTYPE_QNA_FINISH")}</span>
          </div>
          <p className="qna-ans-num" style={{display: props.ssqDocument.answerCnt > 0 ? "" : "none"}}>{props.ssqDocument.answerCnt}</p>
        </div>
        <div className="write-body">
          <div className="title-line"
            onClick={() => {
              if (!loginutil.hasDocViewAuth(loginInfo, props.ssqDocument.displayTarget)) {
                if (loginutil.islogin(loginInfo)) {
                  loginutil.alertDocView(loginInfo, props.ssqDocument.displayTarget);
                } else {
                  showLoginPopup(true);
                }
                return;
              }
              {
                props.ssqDocument.docType === "QNA_Q" ? window.open(`/${country}/${lang}/community/qna/document/${props.ssqDocument.id}`)
                  : props.ssqDocument.docType === "PARTNER_QNA_Q" ? window.open(`/${country}/${lang}/community/partner/qna/document/${props.ssqDocument.id}`)
                    : window.open(`/${country}/${lang}/community/rnd/qna/document/${props.ssqDocument.id}`);
              }
            }}>
            <p className="write-title"> {parse(getHighlightedTextFromHtml(props.ssqDocument.docTitle))}
              <span className="lv-worker" style={{display: `${!isEmployee ? 'none' : ''}`}}>임직원</span>
              {((['RND_QNA_Q', "PARTNER_QNA_Q"].includes(props.ssqDocument.docType)) && checkDate == true) &&
                <span className={"new"} style={{padding: "0", marginLeft: "1rem", background: "transparent"}}>
              <img alt={"new.svg"} src={SsqImages.common.icon.newMark()}/>
            </span>}
            </p>
          </div>
          <p className="write-content" onClick={(e) => {
            if (!loginutil.hasDocViewAuth(loginInfo, props.ssqDocument.displayTarget)) {
              if (loginutil.islogin(loginInfo)) {
                loginutil.alertDocView(loginInfo, props.ssqDocument.displayTarget);
              } else {
                showLoginPopup(true);
              }
              return;
            }
            {
              props.ssqDocument.docType === "QNA_Q" ? window.open(`/${country}/${lang}/community/qna/document/${props.ssqDocument.id}`)
                : props.ssqDocument.docType === "PARTNER_QNA_Q" ? window.open(`/${country}/${lang}/community/partner/qna/document/${props.ssqDocument.id}`)
                  : window.open(`/${country}/${lang}/community/rnd/qna/document/${props.ssqDocument.id}`);
            }
          }}>{parse(getHighlightedTextFromHtml(props.ssqDocument.description))}</p>
          <CommentWrap>
            <SimpleUserProfile userId={props.ssqDocument.writerId} highlightedNickName={props.ssqDocument.writerNickname}
              displayLoginPopup={props.displayLoginPopup}
              askUrl={props.ssqDocument.docType === "QNA_Q"
                ? `${window.location.protocol}//${window.location.host}/${country}/${lang}/community/qna/document/${props.ssqDocument.id}`
                : props.ssqDocument.docType === "PARTNER_QNA_Q"
                  ? `${window.location.protocol}//${window.location.host}/${country}/${lang}/community/partner/qna/document/${props.ssqDocument.id}`
                  : `${window.location.protocol}//${window.location.host}/${country}/${lang}/community/rnd/qna/document/${props.ssqDocument.id}`}/>
            <CommunityPostInfo type={"list"}
              commentList={comment}
              ssqDocument={props.ssqDocument}
              time={props.ssqDocument.updateTime}
              count={props.ssqDocument.clickCount}
              good={props.ssqDocument.goodCount}
              bad={props.ssqDocument.badCount}></CommunityPostInfo>
          </CommentWrap>
        </div>
      </div>
    </li>
  );
};

export default QnaDocListItem;